import $ from 'jquery';

$( window ).on( 'load', () => {

  $( '#toggle-menu' ).on( 'click', () => {
    $( '.nav' ).toggleClass( 'open' );
  });

  $( '.scroll-top' ).on( 'click', ( e ) => {
    e.preventDefault();
    $( 'html, body, .modal' ).scrollTop( 0 );
  });
  
  // check on load if the nav is checked uncheck it for when a user hits the back button
  if ( $( '#toggle-menu' ).is( ':checked' ) ) {
    $( '#toggle-menu' ).prop( 'checked', false );
  }

  // addding no scroll when the menu is open
  const checkbox = document.getElementById( 'toggle-menu' );

  // Hide and remove
  checkbox.addEventListener( 'change', () => {
    $( 'body' ).toggleClass( 'no-scroll' );
  });
});

// checks to see if the body has a overflow afte the window is resized. If it does then remove it
//if a user changes res with the mobile menu open then close it
$( window ).on( 'resize', () => {
  if( $( 'body' ).hasClass( 'no-scroll' ) && window.innerWidth >= 960 ){
    $( 'body' ).removeClass( 'no-scroll' )
  }

  if ( $( '#toggle-menu' ).is( ':checked' ) ) {
    $( '#toggle-menu' ).prop( 'checked', false );
    $( 'body' ).removeClass( 'no-scroll' )
  }
})